module.exports = __webpack_public_path__ + "static/img/mainLogo.8d1e1e0d.png";